if (!customElements.get('soon-product-scents')) {
  customElements.define('soon-product-scents', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      const choices = [...this.querySelectorAll('[data-choice]')];
      const stories = [...this.querySelectorAll('[data-story]')];
      const moodChoices = [...this.querySelectorAll('[data-mood-choice]')];
      const moods = [...this.querySelectorAll('[data-mood]')];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.current = 0;
      const selectMood = index => {
        moods.forEach((mood,i) => { mood.hidden=i!==index; mood.classList.toggle('is-active',i===index); });
        moodChoices.forEach((button,i) => { button.setAttribute('aria-pressed',String(i===index));button.classList.toggle('is-active',i===index); });
        this.mood=index;
      };
      const select = index => {
        this.querySelectorAll('.sp-scent-video').forEach(v=>{v.pause();v.hidden=true;const c=v.closest('[data-cinema]');c.classList.remove('sp-video-open');const b=c.querySelector('[data-reveal]');b.setAttribute('aria-expanded','false');const l=b.querySelector('[data-reveal-label]');l.textContent=l.dataset.openLabel;});
        this.current=(index+stories.length)%stories.length;
        stories.forEach((story,i) => {story.hidden=i!==this.current;});
        choices.forEach((button,i) => {button.setAttribute('aria-pressed',String(i===this.current));button.classList.toggle('is-active',i===this.current);});
        selectMood(this.current);
      };
      const keyboard = (event,current,length,callback,buttons) => {
        if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const next=event.key==='Home'?0:event.key==='End'?length-1:(current+(event.key==='ArrowRight'?1:-1)+length)%length;
        callback(next);buttons[next].focus();
      };
      choices.forEach((button,i) => {
        button.addEventListener('click',()=>select(i),options);
        button.addEventListener('keydown',e=>keyboard(e,this.current,stories.length,select,choices),options);
      });
      moodChoices.forEach((button,i) => {
        button.addEventListener('click',()=>select(i),options);
        button.addEventListener('keydown',e=>keyboard(e,this.mood||0,moods.length,select,moodChoices),options);
      });
      const addSwipe=(element,getCurrent,callback,length) => {
        if(!element)return;
        let start=null;
        element.addEventListener('pointerdown',event=>{
          if(event.target.closest('button,a,summary,video'))return;
          start={x:event.clientX,y:event.clientY};
          element.setPointerCapture?.(event.pointerId);
        },options);
        element.addEventListener('pointerup',event=>{
          if(!start)return;
          const dx=event.clientX-start.x,dy=event.clientY-start.y;
          if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.4)callback((getCurrent()+(dx<0?1:-1)+length)%length);
          start=null;
        },options);
        element.addEventListener('pointercancel',()=>{start=null;},options);
      };
      addSwipe(this.querySelector('.sl-hero-photo'),()=>this.mood||0,select,moods.length);
      stories.forEach(story=>{
        const cinema=story.querySelector('[data-cinema]');
        const reveal=story.querySelector('[data-reveal]');
        const label=reveal.querySelector('[data-reveal-label]');
        const cloud=story.querySelector('.sl-note-cloud');
        const particles=story.querySelector('.sl-particles');
        let frame=null;
        addSwipe(cinema,()=>this.current,select,stories.length);
        reveal.addEventListener('click',()=>{
          const expanded=reveal.getAttribute('aria-expanded')!=='true';
          reveal.setAttribute('aria-expanded',String(expanded));
          label.textContent=expanded?label.dataset.closeLabel:label.dataset.openLabel;
          const video=cinema.querySelector('.sp-scent-video');
          if(video){cinema.classList.toggle('sp-video-open',expanded);video.hidden=!expanded;if(expanded){if(!video.src)video.src=video.dataset.src;video.play().catch(()=>{});}else{video.pause();if(video.readyState)video.currentTime=0;}return;}
          cloud.hidden=!expanded;cinema.classList.toggle('is-revealed',expanded);
          particles.replaceChildren();
          if(expanded&&!reduced.matches){
            for(let i=0;i<42;i++){
              const dot=document.createElement('i');
              const angle=Math.PI*2*i/42;
              dot.style.setProperty('--x',`${Math.cos(angle)*(85+i*3)}px`);
              dot.style.setProperty('--y',`${Math.sin(angle)*(90+i*3)-85}px`);
              dot.style.setProperty('--size',`${2+i%5}px`);
              dot.style.animationDelay=`${i*.012}s`;
              particles.append(dot);
            }
          }
        },options);
        cinema.addEventListener('pointermove',event=>{
          if(!cinema.classList.contains('is-revealed')||reduced.matches||frame)return;
          frame=requestAnimationFrame(()=>{
            const r=cinema.getBoundingClientRect(),x=(event.clientX-r.left)/r.width,y=(event.clientY-r.top)/r.height;
            cinema.style.setProperty('--bloom-x',`${x*100}%`);cinema.style.setProperty('--bloom-y',`${y*100}%`);
            cinema.style.setProperty('--cloud-x',`${(x-.5)*9}px`);cinema.style.setProperty('--cloud-y',`${(y-.5)*7}px`);frame=null;
          });
        },options);
        cinema.addEventListener('pointerleave',()=>{cinema.style.setProperty('--cloud-x','0px');cinema.style.setProperty('--cloud-y','0px');},options);
      });
      document.addEventListener('shopify:block:select',event=>{const story=event.target.closest('[data-story]');if(story&&this.contains(story))select(Number(story.dataset.story));},options);
      const end=Date.parse(this.dataset.deadline),clock=this.querySelector('.sl-clock');
      const update=()=>{
        if(!clock)return;
        if(!Number.isFinite(end)){clock.hidden=true;return;}
        const seconds=Math.max(0,Math.floor((end-Date.now())/1000));
        if(!seconds){clock.textContent=this.dataset.ended;clearInterval(this.timer);return;}
        const values={days:Math.floor(seconds/86400),hours:Math.floor(seconds/3600)%24,minutes:Math.floor(seconds/60)%60,seconds:seconds%60};
        clock.querySelectorAll('[data-clock]').forEach(node=>{node.textContent=String(values[node.dataset.clock]).padStart(2,'0');});
      };
      update();if(Number.isFinite(end)&&end>Date.now())this.timer=setInterval(update,1000);
      const initial=['no-notes-extrait-de-parfum','portrait-in-motion-extrait-de-parfum','afterglow-extrait-de-parfum'].indexOf(this.dataset.initial);
      select(initial<0?0:initial);
      this.querySelectorAll('.sl-personal-cta').forEach(a=>a.addEventListener('click',event=>{const target=document.getElementById('soon-add-to-cart');if(!target)return;event.preventDefault();target.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'center'});target.focus({preventScroll:true});},options));
      const email=document.querySelector('details.se-access--email');if(email?.querySelector('.se-form-status'))email.open=true;
    }
    disconnectedCallback(){this.abort?.abort();clearInterval(this.timer);}
  });
}

